import SMaxWidthContainer from "components/framework/SMaxWidthContainer";
import SSectionHeader from "components/framework/SSectionHeader";
import styled, { css } from "styled-components";

//#region [Props]
export type SGridProps = {
	$columns?: number;
};
//#endregion

//#region [Styles]
const SMaxWidthMovieGrid = styled(SMaxWidthContainer)<SGridProps>`
	padding: 50px 10px;

	display: grid;
	gap: 10px;
	${ props => {
		return css`
			grid-template-columns: repeat(${props.$columns ?? 3}, minmax(0, 1fr));
		`;
	}}


	@media screen and (min-width: 641px) {
		gap: 16px;
		grid-template-columns: repeat(5, minmax(0, 1fr));
	}

`;

export default SMaxWidthMovieGrid;

export const SFullGridRow = css<SGridProps>`
	grid-column: 1 / span ${props => props.$columns ?? 3};
	@media screen and (min-width: 641px) {
		grid-column: 1 / span 5;
	}
`;

export const SMaxWidthMovieGridHeader = styled(SSectionHeader)<SGridProps>`
	${SFullGridRow}
`;

export const SMovieCell = styled.article`
	background-color: var(--color_fpposter_bg_mobile, var(--color_fpposter_bg, #fefefe));

	@media screen and (min-width: 641px ) {
		background-color: var(--color_fpposter_bg, #fefefe); // default to standard color if the inversion is not set
	}
`;

//#endregion